export default __webpack_public_path__ + "static/media/Izzy.00cb18db.png";